import React, { useState } from 'react';
import axios from 'axios';
import { showError, showSuccess } from '../utils/alerts';


const BoletasHonorariosForm = ({ url, id_company, token }) => {
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && !selectedFile.name.endsWith('.xlsx')) {
            showError('Solo se permiten archivos .xlsx');
            return;
        }
        setFile(selectedFile);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            showError('Por favor, selecciona un archivo');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);
        formData.append('id_company', id_company);

        try {
            setIsLoading(true);
            await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`
                },
            });
            showSuccess('Archivo cargado exitosamente');
            setFile(null);
        } catch (error) {
            console.error('Error al cargar el archivo', error);
            showError('Error al cargar el archivo');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <input type="file" onChange={handleFileChange} accept=".xlsx" />
                <button type="submit" disabled={isLoading || !file}>
                    {isLoading ? 'Cargando...' : 'Cargar Archivo'}
                </button>
            </form>
        </div>
    );
};

export default BoletasHonorariosForm;